import { sendAuthRequest } from ".";

const TARIFF_URL = '/api/tariff';

export const setTariff = async (status) => {
    return await sendAuthRequest(`${TARIFF_URL}/change`, 'POST', {subscription_status: status});
};